<template>
  <div class="headTitle-container">
    <h1>知守科技大数据分析平台</h1>
    <p>{{ time }}</p>
    <div
      v-if="href.indexOf('earth=0') === -1"
      class="options"
      @click="toPage('?earth=0')"
    >简约版>></div>
    <div
      v-if="href.indexOf('earth=0') > -1"
      class="options"
      @click="toPage('')"
    >完整版>></div>
  </div>
</template>

<script>
import * as moment from 'moment';

export default {
  name: 'HeadTitle',
  data () {
    return {
      time: moment().format('YYYY-MM-DD HH:mm:ss'),
      timer: '',
      href: ''
    }
  },
  mounted () {
    this.href = window?.location?.href
    this.timer = setInterval(() => { this.time = moment().format('YYYY-MM-DD HH:mm:ss') }, 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    toPage (path) {
      window.location.href = (window.location.origin + '/#/' + path)
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.headTitle-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding-top: 7px;
  color: #fff;
  background: url('@/assets/images/ornament/header.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}

h1 {
  font-size: 50px;
  line-height: 50px;
  letter-spacing: 4px;
}

p {
  font-size: 20px;
  color: #ccc;
  line-height: 30px;
}

.options {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 12px;
  text-decoration: underline;
  color: rgb(205, 211, 211);
  cursor: pointer;
}
</style>